export const PRIMARY_COLOR = '#4d43fa'
// export const BACKGROUND_COLOR = '#bccdf7';
export const BACKGROUND_COLOR = '#fff'
export const SECONDARY_COLOR = '#3237c7'
export const WHITE_COLOR = '#f5f5fa'
export const NO_IMAGE =
	'https://storage.googleapis.com/maskstore-abf18.appspot.com/1653746972475.png'
export const BUTTON_STYLE = {
	backgroundImage:
		'linear-gradient( 94.3deg,  rgba(26,33,64,1) 10.9%, rgba(81,84,115,1) 87.1% )',
}

export const BUTTON_STYLE_2 = {
	backgroundImage:
		'radial-gradient( circle 757px at 14.6% 44.8%,  rgba(60,77,115,1) 27.7%, rgba(0,194,209,1) 95.9% )',
}
